import { RouteObject } from "react-router"
import { lazy } from "react"

const TransactionLogsPage = lazy(() => import("./TransactionLogsPage"))

export const BillingRoutes: RouteObject[] = [
	{ path: "", element: <TransactionLogsPage /> },
]
